import React, { useEffect } from 'react';
import Traductor from '../../components/Traductor';
import userWelcomeSVG from '../../images/icons/user-welcome-icon.png';
import { disableHTMLOverflow } from '../../Functions';

import '../../css/components/shared/ModalFirstBidPreferences.css';
import Globals from '../../Globals';

function ModalFirstBidPreferences({ history }) {

    const t = new Traductor();

    useEffect(() => {
        disableHTMLOverflow(true);
    }, [])

    const goToPreferencesPage = () => {
        disableHTMLOverflow(false);
        history.push(Globals.APPLICATION_PATH.PREFERENCES)
    }

    return (
        <div className="c-modal c-modal--first-bid-preferences" aria-hidden={"false"} id="demo-modal">
            <div className="c-modal__overlay  js-modal-close" tabIndex="-1"></div>
            <div className="c-modal__wrapper" role="dialog" aria-labelledby="foo-bar-baz">
                <header className="c-modal__header">
                    <div className="c-modal__title__wrapper">
                        <img src={userWelcomeSVG} alt="Bienvenido"></img>
                        <h1 className="c-modal__title" id="foo-bar-baz"> {t.getTraduction("ModalFirstBidPreferences_Title")}</h1>
                    </div>
                </header>
                <div className="c-modal__content" role="document">
                    <p>{t.getTraduction("ModalFirstBidPreferences_Body_1")} <strong>{t.getTraduction("ModalFirstBidPreferences_Body_2")}</strong> {t.getTraduction("ModalFirstBidPreferences_Body_3")}</p>
                </div>
                <div className="c-modal__footer">
                    <div className="c-modal__actions">
                        <div className="c-modal__actions__item">
                            <button className="c-btn  js-modal-close  js-modal-autofocus" aria-label="Go to preferences." onClick={goToPreferencesPage}>
                                <span className="c-btn__text">
                                    {t.getTraduction("EditPreferences")}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalFirstBidPreferences;
